'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_StoreCartItemSearch(storeCartId_$_lo, storeCartId_$_hi, onlyOpen, pageIndex, pageSize, sort) {
  this.NH = 0;
  this.NI = 0;
  this.LE = false;
  this.LF = 0;
  this.LG = 0;
  this.LH = null;
  this.NH = storeCartId_$_lo;
  this.NI = storeCartId_$_hi;
  this.LE = onlyOpen;
  this.LF = pageIndex;
  this.LG = pageSize;
  this.LH = sort;
}
export { $c_Lmealorama_StoreCartItemSearch as $c_Lmealorama_StoreCartItemSearch };
$p = $c_Lmealorama_StoreCartItemSearch.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_StoreCartItemSearch;
/** @constructor */
function $h_Lmealorama_StoreCartItemSearch() {
}
export { $h_Lmealorama_StoreCartItemSearch as $h_Lmealorama_StoreCartItemSearch };
$h_Lmealorama_StoreCartItemSearch.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (-282865412));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.NH, this.NI)));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.LE ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.LF);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.LG);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.LH));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 5);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_StoreCartItemSearch)) {
    if ((((this.LE === x$0.LE) && (this.LF === x$0.LF)) && (this.LG === x$0.LG))) {
      var x_$_lo = this.NH;
      var x_$_hi = this.NI;
      var $x_2 = x$0;
      var x$1_$_lo = $x_2.NH;
      var x$1_$_hi = $x_2.NI;
      var $x_1 = (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$2 = this.LH;
      var x$2$1 = x$0.LH;
      return ((x$2 === null) ? (x$2$1 === null) : x$2.f(x$2$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 5;
});
$p.r = (function() {
  return "StoreCartItemSearch";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.NH, this.NI);
      break;
    }
    case 1: {
      return this.LE;
      break;
    }
    case 2: {
      return this.LF;
      break;
    }
    case 3: {
      return this.LG;
      break;
    }
    case 4: {
      return this.LH;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_StoreCartItemSearch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k0)));
}
export { $isArrayOf_Lmealorama_StoreCartItemSearch as $isArrayOf_Lmealorama_StoreCartItemSearch };
var $d_Lmealorama_StoreCartItemSearch = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_StoreCartItemSearch, "mealorama.StoreCartItemSearch", ({
  k0: 1,
  bB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_StoreCartItemSearch as $d_Lmealorama_StoreCartItemSearch };
//# sourceMappingURL=mealorama.-Store-Cart-Item-Search.js.map
